module.exports = {
  'en-US': 'English',
  'es-ES': 'Espa\xF1ol',
  'tl-PH': 'Tagalog',
};
